import React from "react"
import BoardMeeting from "./widgets/boardMeeting"
import Documents from "./widgets/documents"
import ServiceRate from "./widgets/serviceRate"
import TaxRate from "./widgets/taxRate"
import Budget from "./widgets/budget"
import ContactForm from "./widgets/contactForm"
import DistrictSearch from "./widgets/districtSearch"
import AlertForm from "./widgets/alertForm"

const Widget = ({settings, name}) => {
    switch (name) {
        case "Board Meeting":
            return(<BoardMeeting />)
        case "Document":
            return(<Documents />)
        case "Service Rate":
            return(<ServiceRate />)
        case "Tax Rate":
            return(<TaxRate />)
        case "Budget":
            return(<Budget />)
        case "Contact Form":
            return(<ContactForm />)
        case "Alert Form":
            return(<AlertForm settings={settings} />)
        case "District Search":
            return(<DistrictSearch />)
        default:
            return (<h1>{name} Widget</h1>)
    }
}

export default Widget